module.exports = __webpack_public_path__ + "static/media/unit 1-8.c4ff10cb.jpg";